<template>
	<div class="container-fluid bg-white">
		<service-contract-toolbar 
			:customer-name="customerName">		
		</service-contract-toolbar>

		<vue-form :save-buttons-hidden="true">

			<h2>
				Materials<br>
				<small>Service Contract #{{$store.serviceContract.contract_num}}</small>
			</h2>

			<p>Add references to materials here, so service crew members can conveniently find the materials they've used when working on a service contract work order.</p>

			<table-list
				record-name="Item"
				:fields="fields"
				:records="mutatedMaterials"
				:has-delete="true"
				:sortable="true"
				v-on:delete="deleteMaterial">

				<button class="btn btn-success" type="button" v-on:click="addMaterial">
					<i class="fa fa-plus"></i>
					Add Material
				</button>

			</table-list>
		</vue-form>

		<material-selector-modal :visible="materialModalVisible"
			:disable-manual="true"
			:disable-qty="true"
			:disable-assemblies="true"
			v-on:closeModal="materialModalVisible = false"
			v-on:addMaterials="confirmAddMaterials">		
		</material-selector-modal>

	</div>
</template>
<script type="text/javascript">
import Field from "@/components/Field"
import TableList from "@/components/TableList"
import VueForm from "@/components/VueForm"
import ModalDialog from "@/components/ModalDialog"
import Widget from "@/components/Widget"
import MaterialSelectorModal from "@/components/super_components/MaterialSelectorModal"

import ServiceContractToolbar from "./ServiceContractToolbar"
import ServiceContractMixins from "@/mixins/ServiceContractMixins.js"

export default {
	name: "ServiceContractMaterials",
	components: {
		ServiceContractToolbar,
		TableList,
		VueForm,
		Field,
		ModalDialog,
		Widget,
		MaterialSelectorModal
	},
	mixins: [ServiceContractMixins],
	data() {
		return {
			fields: [
				{label: "Part Number",key:"part_number"},
				{label: "Description",key:"description"},
				{label: "Category", key: "parentCategoryName"}
			],
			materialModalVisible: false
		}
	},
	computed: {
		mutatedMaterials() {
			if (this.$store.serviceContract && "Material" in this.$store.serviceContract && this.$store.serviceContract.Material) {

				return this.$store.serviceContract.Material.map(mat => {
					mat.parentCategoryName = mat.MaterialCategory.name

					return mat
				})
			}
			else
				return []
		}
	},
	methods: {
		addMaterial() {
			this.materialModalVisible = true
		},
		confirmAddMaterials(materials) {
			let vm = this

			let payloadIds = materials.map(mat => {
				return mat.id
			})

			let materialIds = this.$store.serviceContract.Material.map(mat => {
				return mat.id
			})

			materialIds = materialIds.concat(payloadIds)

			this.syncList(materialIds).then(response => {
				if (response.success)
					vm.materialModalVisible = false
			})
		},
		deleteMaterial(material) {
			console.log(this.$store.serviceContract.Material.map(mat => mat.id), material)

			let materialIds = this.$store.serviceContract.Material.filter(mat => mat.id != material.id).map(mat => mat.id)

			console.log(JSON.stringify(materialIds))

			this.syncList(materialIds)
		},
		syncList(matIds) {
			let vm = this

			//remove duplicates
			let uniqueMaterialIds = []
			matIds.forEach(id => {
				if (uniqueMaterialIds.indexOf(id) == -1)
					uniqueMaterialIds.push(id);
			})

			let payload = {
				id: this.$store.serviceContract.id,
				Material: uniqueMaterialIds
			}

			return new Promise((resolve,reject) => {

				//sync list
				vm.postData("ServiceContract/save",payload,true).then(response => {
					if (response.success) 
						vm.fetchContract(vm.$route.params.slug).then(response => {
						})

					resolve(response)
				})
			})
		},
		fetchMaterials() {
			let vm = this

			let params = {
				filters: [
					["contract_id",]
				]
			}
		}
	},
	created() {
		this.fetchContractIfNotSet(this.$route.params.slug)
	}
}
</script>